<template>
  <ChatInterface
    :coach="elonCoach"
    apiEndpoint="/api"
    coachName="Elon"
  />
</template>

<script>
import ChatInterface from '../components/ChatInterface.vue';

export default {
  name: 'CoachElon',
  components: {
    ChatInterface,
  },
  data() {
    return {
      elonCoach: {
        image: require('../assets/image-6.jpg'),
        name: 'ELON',
        description: [
          'Un gemelo digital basado en la información pública atribuida a Elon Musk, trata de reflejar la personalidad y conocimientos de Elon Musk.',
          'ELON 1.0 es duro, no es cómodo hablar con el ya que te estará desafiando constantemente, pero si logras interesarlo te dará consejos e información extremadamente valiosa para tu emprendimiento y/o tu carrera.',
        ],
        disclaimer:
          'Este chat usa un modelo de IA experimental y está en etapa de pruebas, no incluyas información personal ni confidencial ya que podría ser usada para entrenamiento. Este es un proyecto de simulación. No es una representación fiel del personaje y el análisis que se proporciona es con fines orientativos. Elon Musk no está enterado de este proyecto (hasta donde sabemos)',
      },
    };
  },
};
</script>